import { versionString } from 'src/components/base-components/Version/Version';
import { getSkinId } from 'src/helpers/utils';
import { ArticlesRes, GamCare } from 'src/types/res-dto/page-res';
import { APP_API_VERSION } from 'src/utils/constants';
import HttpClient from './http';

const getHelpCenterArticles = (): Promise<ArticlesRes[]> => {
  return HttpClient.get(`/mock/staticData/articles.json`, false);
};

const getPaymentsLogos = (): Promise<any> => {
  const skinId = getSkinId();
  return HttpClient.get(
    {
      path: `${APP_API_VERSION}/getPaymentMethodsIcons`,
      baseURL: process.env.REACT_APP_REMOTE as string,
    },
    false,
    { hierarchyId: skinId }
  );
};

const getGamCare = (): Promise<GamCare[]> => {
  return HttpClient.get(`/mock/staticData/gamCare.json`, false);
};

const reportProblem = (error: any): Promise<any> => {
  const user: any = localStorage.getItem('user');
  const userInfo = user ? JSON.parse(user).id : 'Unauthorised user';
  const userAgent = window.navigator.userAgent;
  const timeUTC = new Date().toISOString();

  const userAgentStr = `userAgent -> ${userAgent} `;
  const userInfoStr = `userInfo -> ${userInfo} `;
  const errorStackStr = `stack -> ${error?.stack} `;
  const errorMessageStr = `errorMessage -> ${error?.message} `;
  const errorAdditionalMessageStr = error?.additionalMessage
    ? `errorAdditionalMessage -> ${error?.additionalMessage} `
    : '';
  const timeStr = `timeUTC -> ${timeUTC} `;
  const versionStr = `version -> ${versionString} `;

  const message =
    userAgentStr + userInfoStr + errorStackStr + errorMessageStr + errorAdditionalMessageStr + timeStr + versionStr;

  return HttpClient.post(
    {
      path: `${APP_API_VERSION}/sendWarningEmail`,
      baseURL: process.env.REACT_APP_REMOTE as string,
    },
    {
      message,
    },
    false
  );
};

export { getGamCare, getHelpCenterArticles, getPaymentsLogos, reportProblem };
